import React from 'react';
import { CustomTextField } from '../../../../components/CustomTextField';
import { InputAdornment } from '@mui/material';
import { EmailSubsectionChip } from '../../../../components/buttons/IconButtons';
import ButtonAction from '../../../../components/buttons/ButtonAction';
import GeneralStepBody from "./GeneralStepBody";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 19 de 05 de 2026
 */

const EnterEmailAddress = (props) => {
    const { email, setEmail, handleEmailChange, handleKeyDown, isValidEmail, emptyFields, t,handleEmailSend} = props;

    return (
        <GeneralStepBody t={t} title='enter_email_address' description='email_confirmation_code_description'>
            <div className='d-flex flex-column gap-3 mt-3 w-100'>
                <CustomTextField
                    id={'txt_eea_email'}
                    length={128}
                    name={'email'}
                    value={email}
                    trans={'email'}
                    type={'text'}
                    disabled={false}
                    onChange={(e) => {
                        setEmail(e.target.value);
                        handleEmailChange(e);
                    }}
                    required={true}
                    emptyFields={emptyFields}
                    isValid={isValidEmail}
                    isValidText={'email_format_invalid'}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position='end'>
                                <EmailSubsectionChip className='w-24px h-24px' />
                            </InputAdornment>
                        ),
                    }}
                    onKeyDown={handleKeyDown}
                />
                <div className='col-12 mt-3 p-0 w-100'>
                    <ButtonAction
                        id='btn_eea_forgot_password'
                        name={'send'}
                        disabled={false}
                        className='btn-icon-add w-100'
                        onClick={ () => {handleEmailSend()}}
                    />
                </div>
            </div>
        </GeneralStepBody>
    );
};

export default EnterEmailAddress;
